import { RELAY_API_CONTENTFUL } from "@/utils/constant";

import {
    PricingPageRelayQuery,
    getPricingPageRelayQueryVars
} from "../contentful/graphql";
import { init as initRelay } from "../init-relay-streaming";
import { ConfluencePricingPage } from "../pages/software/confluence/pricing/confluence-pricing-page";
import { getPricingTitleInternal } from "../pages/software/confluence/pricing/feature-gates";

const pricingTitleInternal = getPricingTitleInternal();

initRelay(
    ConfluencePricingPage,
    PricingPageRelayQuery,
    getPricingPageRelayQueryVars(
        "confluence",
        window.location,
        pricingTitleInternal
    ),
    RELAY_API_CONTENTFUL
);
